let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bHJFC")).then(() => parcelRequire('eFZZD'));